import apis from '../apis/apis'

const reportProcessor = {}
const controllerName = 'Report'

reportProcessor.banGiaoVanBang = async ({ khoaThiId, truongId, ngayBatDau, ngayKetThuc }) => {
  const rs = await apis[controllerName].BanGiaoVanBang({
    param: `/${khoaThiId}?ngayBatDau=${ngayBatDau}&ngayKetThuc=${ngayKetThuc}&truongId=${truongId}`,
  })
  return rs.isSuccess ? rs.data : []
}
reportProcessor.xepLoai = async ({ khoaThiId }) => {
  const rs = await apis[controllerName].ReportXepLoai({
    param: `/${khoaThiId}`,
  })
  return rs.isSuccess ? rs.data : []
}
reportProcessor.nam = async () => {
  const rs = await apis[controllerName].ReportNam({})
  return rs.isSuccess ? rs.data : []
}
reportProcessor.tongSo = async (id) => {
  const rs = await apis[controllerName].TongSo({ param: `/${id}` })
  return rs.isSuccess ? rs.data : {}
}
reportProcessor.banGiaoVanBangChiTiet = async ({
  khoaThiId,
  truongId,
  ngayBatDau,
  ngayKetThuc,
  skip,
  take,
}) => {
  const rs = await apis[controllerName].BanGiaoVanBangChiTiet({
    param: `/${khoaThiId}?skip=${skip}&take=${take}&ngayBatDau=${ngayBatDau}&ngayKetThuc=${ngayKetThuc}&truongId=${truongId}`,
  })
  return rs.isSuccess ? rs.data : { values: [], totalItemsCount: 0 }
}
export default reportProcessor
